
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 72 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.498 10l-55.713.324v36.391h2.957","stroke":"#616161"}}),_c('path',{attrs:{"d":"M8.256 14.701l24.8 19.781 30.756-20.11","stroke":"#616161","stroke-linejoin":"bevel"}}),_c('path',{attrs:{"d":"M63.812 36.895V14.25l-55.714.325v36.39h28.956","stroke":"#616161"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.549 32.217l-.982 27.898 32.02-3.608-.422-25.818-30.616 1.528z","fill":"#CFF8E1"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M40.287 34.088l.928 26.357h26.566l.531-26.566-28.025.21z","stroke":"#616161"}}),_c('path',{attrs:{"d":"M49.719 45.492l5.46 6.77L71.3 35.472","stroke":"#616161"}})])
          )
        }
      }
    